const exportActionType = {
    SET_EXPORT_DATA:  'SET_EXPORT_DATA',
}

export default exportActionType;
